import { Box, Container, Typography } from "@mui/material";

import { useTranslation } from "next-i18next";

import React from "react";

import AlternateArticleLanguage from "../../../../components/Atoms/AlternateLanguage";
import Tags from "../../../../components/Molecules/Tags";
import WebShare from "../../../../components/Molecules/WebShare";
import PortableText from "../../../portableText";
import { ArticleDetailType } from "../../queries";
import ArticleButton from "../ArticleButton";

export type PostProps = {
    post: ArticleDetailType;
    alternateContent: { href: string; hrefLang: "en" | "fr" | "de"; fallback: boolean }[];
    locale: string;
};

const Post = ({ post, alternateContent, locale }: PostProps) => {
    const { t } = useTranslation(["article", "common"]);

    return (
        <div>
            <Container>
                <AlternateArticleLanguage
                    languages={alternateContent
                        .filter((item) => !item.fallback)
                        .map((item) => ({
                            href: item.href,
                            hrefLang: item.hrefLang
                        }))}
                />
            </Container>

            <Box component="article" data-content="main">
                <PortableText.Render value={post.body} />
            </Box>

            <WebShare
                label={t("share")}
                shareData={{
                    title: post.title,
                    text: post.excerpt,
                    url: locale === "en" ? post.path : `/${locale}${post.path}`
                }}
            />

            <hr />

            <Typography component="h3" variant="h5" mb={2}>
                {t("otherPosts")}
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                {post.previousPost ? (
                    <ArticleButton
                        href={post.previousPost.path}
                        title={`${t("previousPost")}: ${post.previousPost.title}`}
                        direction="left"
                    />
                ) : (
                    <Box sx={{ width: "100%" }} />
                )}

                {post.nextPost ? (
                    <ArticleButton
                        href={post.nextPost.path}
                        title={`${t("nextPost")}: ${post.nextPost.title}`}
                        direction="right"
                    />
                ) : (
                    <Box sx={{ width: "100%" }} />
                )}
            </Box>

            <hr />

            <Typography component="h3" variant="h5" mb={2}>
                {t("taggedWith")}:
            </Typography>

            {post.tags?.length ? (
                <Tags
                    tags={post.tags.map((tag) => ({
                        name: tag.name,
                        slug: tag.slug.current,
                        path: tag.path
                    }))}
                />
            ) : null}

            <hr />
        </div>
    );
};

export default Post;
